/* eslint-disable */
import React from 'react';
import {
  Autocomplete,
  Chip,
  TextField,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Button,
} from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import FilterOptionRadioGroup from './filterOptionRadioGroup';
import styles from './scopeFE.module.scss';
import PropTypes from 'prop-types';


const ExpandedContent = ({ id, row, isEditable, filterOptions, handleInputChange, handleIncrement, handleDecrement, handleSave, handleCancel }) => {
  const handleDelete = (apiToDelete) => {
    const updatedApis = (row.totalApisUsed || []).filter(
      (api) => api !== apiToDelete
    );
    handleInputChange(id, 'totalApisUsed', updatedApis);
  };

  const isSaveDisabled = () => {
    if (row.epicStory_dropdown === 'Story' || row.epicStory_dropdown === 'Sub-Story') {
      return !(
        row.feEffortComplexity &&
        row.requirementClarity &&
        row.technicalComplexity &&
        row.externalIntegration
      );
    }
    return false;
  };

  return (
    <div key={`expanded-${id}`} className={styles['ScopeFE-expanded']}>
      <div className={styles['ScopeFE-innerContainer']}>
        <div className={styles['ScopeFE-container1']}>
          {[
            'feEffortComplexity',
            'requirementClarity',
            'technicalComplexity',
            'externalIntegration',
          ].map((field, index) => (
            <div className={styles['ScopeFE-subcontainer1']} key={field}>
              <FilterOptionRadioGroup
                key={field}
                options={filterOptions[index].options}
                value={row[field] ? String(row[field]) : ''}
                onChange={(e) => handleInputChange(id, field, e.target.value)}
                label={filterOptions[index].name}
                disabled={!isEditable}
              />
            </div>
          ))}
        </div>
        <div className={styles['ScopeFE-container2']}>
          <div className={styles['ScopeFE-autocompleteContainer2']}>
            <div className={styles['ScopeFE-gridItem-heading']}>
              Total API (Override)
            </div>

            <OutlinedInput
              value={row.totalApiOverride || '0'}
              onChange={(e) =>
                handleInputChange(id, 'totalApiOverride', e.target.value)
              }
              type="number"
              startAdornment={
                <InputAdornment position="start">
                  <IconButton
                    onClick={() => handleDecrement(id, 'totalApiOverride')}
                    size="small"
                    disabled={!isEditable || row.totalApiOverride <= 0}
                  >
                    <RemoveIcon fontSize="small" sx={{ fontSize: '14px' }} />
                  </IconButton>
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleIncrement(id, 'totalApiOverride')}
                    size="small"
                    disabled={!isEditable}
                  >
                    <AddIcon fontSize="small" sx={{ fontSize: '14px' }} />
                  </IconButton>
                </InputAdornment>
              }
              inputProps={{
                style: { textAlign: 'center' },
                readOnly: !isEditable,
              }}
              sx={{
                backgroundColor: '#ffffff !important',
                '&.MuiOutlinedInput-root': {
                  backgroundColor: '#ffffff !important',
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  backgroundColor: '#ffffff !important',
                  padding: '0',
                },
              }}
              className={styles.feEffortOverrideInput}
              disabled={!isEditable}
            />
          </div>

          <div className={styles['ScopeFE-autocompleteContainer']}>
            <div className={styles['ScopeFE-gridItem-heading']}>
              <div className={styles['ScopeFE-gridItem-heading']}>
                {isEditable
                  ? "Total APIs Used (5 API's)"
                  : `Total APIs Used (${row.totalApisUsed?.length} API's)`}
              </div>
            </div>
            <Autocomplete
              disabled={!isEditable}
              multiple
              freeSolo
              options={[]}
              value={row.totalApisUsed || []}
              onChange={(event, newValue) => {
                if (newValue.length <= 10) {
                  handleInputChange(id, 'totalApisUsed', [
                    ...new Set(newValue),
                  ]);
                }
              }}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={`${option}-${index}`}
                    label={option}
                    {...getTagProps({ index })}
                    onDelete={() => handleDelete(option)}
                    className={styles.customChip}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Enter API "
                  onKeyDown={(event) => {
                    if (
                      event.key === 'Enter' &&
                      event.target.value.trim() !== ''
                    ) {
                      event.preventDefault();
                      const newApi = event.target.value.trim();

                      if ((row.totalApisUsed || []).length < 5) {
                        handleInputChange(id, 'totalApisUsed', [
                          ...(row.totalApisUsed || []),
                          newApi,
                        ]);
                        event.target.value = '';
                      }
                    }
                  }}
                  className={styles.customTextField}
                />
              )}
            />
          </div>
        </div>

        {isEditable && (
          <div className={styles['ScopeFE-gridItem-buttons']}>
            <Button
              variant="contained"
              size="small"
              onClick={() => handleSave(id)}
              className={styles.saveButtonStyle}
              startIcon={<CheckIcon />}
              disabled={isSaveDisabled()}
              sx={{
                opacity: isSaveDisabled() ? 0.5 : 1,
                cursor: isSaveDisabled() ? 'not-allowed' : 'pointer',
              }}
            ></Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleCancel(id)}
              className={styles.cancelButtonStyle}
              startIcon={<ClearIcon />}
            ></Button>
          </div>
        )}
      </div>
    </div>
  );
};

ExpandedContent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  row: PropTypes.shape({
    feEffortOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalApisUsed: PropTypes.arrayOf(PropTypes.string),
    totalApiOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    epicStory_dropdown: PropTypes.string.isRequired,
    feEffortComplexity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    requirementClarity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    technicalComplexity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    externalIntegration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  isEditable: PropTypes.bool.isRequired,
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      options: PropTypes.array.isRequired,
    })
  ).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleIncrement: PropTypes.func.isRequired,
  handleDecrement: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  totalApiOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ExpandedContent;
